import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import fs from 'fs';
// const homedir = require('os').homedir();
@Component({
  selector: 'ngx-show-dates',
  templateUrl: './show-dates.component.html',
  styleUrls: ['./show-dates.component.scss']
})
export class ShowDatesComponent implements OnInit {
  rows: { "show": boolean, fileName: string, lines: any[] }[] = []
  fileName: string = "data/RL1"
  columnTitles: string[] = []
  constructor(private http: HttpClient) { }
  ngOnInit(): void {
    this.getCSV()
  }


  getCSV() {
    this.http.get(`assets/${this.fileName}.csv`, { responseType: 'text' }).subscribe((res: any) => {
      this.getLastDates(res)
    })
  }

  getLastDates(data: any) {

    let rowsData = this.simpleCsvJSONJson(data)
    const columnToSort = 'date';
    let numDatesToExtract = 0;

    rowsData.sort((a: any, b: any) => b.date.localeCompare(a.date));

    let count = 0;
    let previousDate = rowsData[0]["date"];

    for (let i = 0; i < rowsData.length && count < 11; i++) {
      let currentDate = rowsData[i + 1] ? rowsData[i + 1]["date"] : null;

      if (previousDate !== currentDate) {
        count++;
        numDatesToExtract = i + 1;
      }

      previousDate = currentDate;
    }

    const latestDates = rowsData.slice(0, numDatesToExtract);
    const pagesLast = latestDates.map(row => parseInt(row["page"]));

    const filteredRows = rowsData.filter(row => pagesLast.includes(parseInt(row["page"])));
    filteredRows.sort((a: any, b: any) => b.date - a.date);
    this.rows.push({ "show": true, fileName: this.fileName, lines: filteredRows })
    this.columnTitles = Object.keys(rowsData[0]);
    console.log(this.rows);
    const csvData = [this.columnTitles.join(',')];

    filteredRows.forEach(row => {
      const rowData = Object.values(row)
        .map(value => {
          if (typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
          }
          return value;
        })
        .join(',');

      csvData.push(rowData);
    });




  }

   mWindow;

  openPdf(pageNumber: number) {
    console.log(pageNumber);
    
    console.log("openPDF", pageNumber);
    var pdfPath = `assets/${this.fileName}.pdf`;
    var windowName = "pdfWindow_" + Date.now(); // Append timestamp for a unique window name
    var url = pdfPath + "#page=" + pageNumber;
    if (this.mWindow) {
      this.mWindow.location.href = url;
      this.mWindow.location.reload();
    } else {
      this.mWindow = window.open(url, windowName);

    }
  }


simpleCsvJSONJson(csv) {

  var lines = csv.split("\n");

  var result = [];

  // NOTE: If your columns contain commas in their values, you'll need
  // to deal with those before doing the next step 
  // (you might convert them to &&& or something, then covert them back later)
  // jsfiddle showing the issue https://jsfiddle.net/
  var headers = lines[0].split(",");

  for (var i = 1; i < lines.length; i++) {

    var obj = {};
    var currentline = lines[i].split(",");

    for (var j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentline[j];
    }

    result.push(obj);

  }

  //return result; //JavaScript object
  return (result); //JSON
}

}




interface RowData {
  [key: string]: any;
}

